import { api } from "./api";
import { publicEndpoints } from "../constants/endpoints";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export type SignupData = {
  name: string;
  email: string;
  companyName: string;
  password: string;
  signup_type: string;
};

export const submitSignupForm = async (data: SignupData) => {
  try {
    const response = await api.post(`/${publicEndpoints.signup}`, data);
    return response.data;
  } catch (error: any) {
    if (error?.response?.data) {
      console.error("Signup error:", error.response.data);
    } else {
      console.error("Signup error:", error.message || "Unknown error");
    }
    throw error;
  }
};
